import './errorHandling'
import '@slite/style'

import { render } from 'react-dom'
import { App } from 'routes'
import { saveReferralToken } from './helpers/referralToken'

saveReferralToken()

render(<App />, document.getElementById('root'))
